import { giftcard as giftcardApi, suppliers } from "@/api";
import axios from "axios";
import dayjs from "dayjs";

/* eslint no-param-reassign: ["error"] */
const currentState = {
  giftcards: [],
  experienced_at: null,
  experienced_dates: [],
  invoice_details: [],
  invoice_details_count: null,
  error: "",
};

const mutations = {
  set_vouchers(state, giftcards) {
    state.giftcards = giftcards;
  },
  failed_validation(state, message) {
    state.error = message.code[0];
  },
  set_invoice_details_count(state, count) {
    state.invoice_details_count = count;
  },
  reset_errors(state) {
    state.error = "";
  },
  set_experienced_at(state, date) {
    state.experienced_at = date;
  },
  update_list_of_dates (state, date) {
    state.experienced_dates.push(date);
  }
};

const actions = {
  async getInvoiceDetailsCount({ commit }) {
    try {
      const { data } = await suppliers.invoices();
      console.log(data);
      commit("set_invoice_details_count", data);
    } catch ({ response }) {}
  },
  async validate({ commit }, { code, errors }) {
    if (code === null) {
      commit("reset_errors");
      commit("set_vouchers", { giftcards: [] });
      return;
    }
    try {
      const { data } = await giftcardApi.validateNew(code);
      commit("set_vouchers", data);
      commit("reset_errors");
    } catch ({ errors }) {
      commit("set_vouchers", { giftcards: [] });
      if (errors) {
        commit("failed_validation", errors);
      }
    }
  },
  async use({ state, dispatch, commit }, giftcard) {
    try {
      await giftcardApi.redeem(
        giftcard.id,
        state.experienced_at ? dayjs(state.experienced_at) : null
      );

      commit("reset_errors");

      if (state.giftcards.length > 1) {
        dispatch("validate", { code: giftcard.code, errors: false });
      } else {
        commit("set_vouchers", { giftcards: [] });
      }
      dispatch("invoices/getInvoices", {}, { root: true });
    } catch (error) {
      console.log(error);
      commit("failed_validation", error.data);
    }

    return giftcard;
  }
};

const getters = {
  giftcards: (state) => state.giftcards,
  invoice_details: (state) => state.invoice_details,
  invoice_details_count: (state) => state.invoice_details_count,
  experienced_at: (state) => state.experienced_at,
  experienced_dates: (state) => state.experienced_dates,
  error: (state) => state.error
};

export default {
  namespaced: true,
  state: currentState,
  getters,
  actions,
  mutations,
};
